import script from "./Sanchan1_hongshu.vue?vue&type=script&setup=true&lang=js"
export * from "./Sanchan1_hongshu.vue?vue&type=script&setup=true&lang=js"

import "./Sanchan1_hongshu.vue?vue&type=style&index=0&id=75a73b1e&lang=less&scoped=true"
script.__scopeId = "data-v-75a73b1e"

export default script